import React, { useContext } from "react";
import { Row, Col, Button } from "antd";
import { FaBackspace } from "react-icons/fa";

import { GlobalContext } from "../../GlobalContext";
import { hiraganaList } from "./hiragana";

const HiraganaKeyboard = ({ player }) => {
    const { userData, setProfile } = useContext(GlobalContext);

    const rows = [
        5, 5, 5, 5, 5, 5, 5, 5, 1, 5, 5, 5, 5, 5, 3, 3, 5, 4, 1, 1, 4,
    ];
    let charIndex = 0;

    let profileDataKey;

    if (player === 1) {
        profileDataKey = "profile_p1";
    } else if (player === 2) {
        profileDataKey = "profile_p2";
    }

    const renderRows = () => {
        // Map hiragana buttons to rows and columns
        return rows.map((row, rowIndex) => {
            const cols = row;

            return (
                <Row
                    key={rowIndex}
                    gutter={10}
                    style={{
                        marginBottom: "10px",
                    }}
                >
                    {
                        // Map hiragana buttons to columns
                        Array.from(Array(cols)).map((_, colIndex) => {
                            const hiragana = hiraganaList[charIndex];

                            charIndex++;

                            let span = null;

                            if (cols === 1) {
                                span = 24;
                            }
                            if (cols === 3) {
                                span = 8;
                            }
                            if (cols === 4) {
                                span = 6;
                            }

                            return (
                                <Col key={colIndex} span={span}>
                                    <Button
                                        type="outline"
                                        size="large"
                                        style={{
                                            width: "100%",
                                            height: "60px",
                                        }}
                                        onClick={() => {
                                            // Add hiragana to userName array
                                            if (profileDataKey) {
                                                let userName = [
                                                    ...userData[profileDataKey]
                                                        .userName,
                                                ];
                                                userName.push(hiragana.key);
                                                setProfile(
                                                    {
                                                        ...userData[
                                                            profileDataKey
                                                        ],
                                                        userName,
                                                    },
                                                    player
                                                );
                                            }
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "18px",
                                                display: "block",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {hiragana.value}
                                        </span>

                                        <span
                                            style={{
                                                fontSize: "12px",
                                                display: "block",
                                            }}
                                        >
                                            {hiragana.key}
                                        </span>
                                    </Button>
                                </Col>
                            );
                        })
                    }
                </Row>
            );
        });
    };

    return (
        <>
            <div
                style={{
                    maxHeight: `300px`,
                    overflowY: `auto`,
                    overflowX: `hidden`,
                    paddingRight: `10px`,
                }}
            >
                {renderRows()}
            </div>
            <Row
                gutter={10}
                style={{
                    marginTop: "10px",
                }}
            >
                <Col span={24}>
                    <Button
                        type="outline"
                        danger
                        style={{
                            width: "100%",
                            fontSize: "18px",
                        }}
                        onClick={() => {
                            // Remove last item from userName array
                            if (profileDataKey) {
                                let userName = [
                                    ...userData[profileDataKey].userName,
                                ];
                                userName.pop();
                                setProfile(
                                    {
                                        ...userData[profileDataKey],
                                        userName,
                                    },
                                    player
                                );
                            }
                        }}
                    >
                        <FaBackspace />
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default HiraganaKeyboard;
